import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

function ReportIcon(props: SvgIconProps) {
	return (
		<SvgIcon viewBox="0 0 19 20" {...props}>
			<path
				d="M7.22612 6.16655H11.932M7.22612 9.30381H11.932M7.22612 12.4411H10.3634M5.65749 3.0293H13.5006C14.367 3.0293 15.0693 3.7316 15.0693 4.59792V15.5783C15.0693 16.4446 14.367 17.1469 13.5006 17.1469H5.65749C4.79117 17.1469 4.08887 16.4446 4.08887 15.5783V4.59792C4.08887 3.7316 4.79117 3.0293 5.65749 3.0293Z"
				stroke="#1A0638"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
				fill="none"
			/>
		</SvgIcon>
	);
}

export default ReportIcon;
